export const EXCHANGES = [
  { slug: "binance", name: "Binance", color: "#F0B90B", markets: ["spot", "futures", "both"], desc: "World's largest crypto exchange by volume." },
  { slug: "bybit", name: "Bybit", color: "#F7A600", markets: ["spot", "futures", "both"], desc: "Derivatives-focused exchange with deep liquidity." },
  { slug: "okx", name: "OKX", color: "#FFFFFF", markets: ["spot", "futures", "both"], desc: "Global exchange with advanced trading tools." },
  { slug: "kucoin", name: "KuCoin", color: "#24AE8F", markets: ["spot", "futures", "both"], desc: "Wide altcoin selection and futures markets." },
  { slug: "bitget", name: "Bitget", color: "#00F0FF", markets: ["spot", "futures", "both"], desc: "Copy-trading native derivatives exchange." },
  { slug: "coinbase", name: "Coinbase", color: "#0052FF", markets: ["spot"], desc: "Regulated US exchange, spot markets." },
];

export const getExchange = (slug) => EXCHANGES.find((e) => e.slug === slug) || { slug, name: slug, color: "#D4AF37", markets: ["both"], desc: "" };

export const MARKETS = [
  { value: "spot", label: "Spot" },
  { value: "futures", label: "Futures (USDⓈ-M)" },
  { value: "both", label: "Spot + Futures" },
];

// Exchanges shown in the partner "Connect a New API Key" picker (with region variants).
export const CONNECT_EXCHANGES = [
  { slug: "hyperliquid", name: "HyperLiquid", color: "#50D2C1" },
  { slug: "bybit", name: "Bybit", color: "#F7A600" },
  { slug: "bitget", name: "Bitget", color: "#00F0FF" },
  { slug: "okx", name: "OKX", color: "#F5F5F5" },
  { slug: "okx-eu", name: "OKX", region: "EU", color: "#F5F5F5" },
  { slug: "kucoin", name: "Kucoin", color: "#24AE8F" },
  { slug: "binance", name: "Binance", color: "#F0B90B" },
  { slug: "kraken", name: "Kraken", color: "#7B68EE" },
  { slug: "bybit-eu", name: "Bybit", region: "EU", color: "#F7A600" },
  { slug: "okx-usaus", name: "OKX", region: "US/AUS", color: "#F5F5F5" },
  { slug: "kraken-inverse", name: "Kraken", region: "INVERSE", color: "#7B68EE" },
  { slug: "gateio", name: "GateIO", color: "#2354E6" },
];
